import React, { useState, useCallback } from "react";

import { useNavigate, useRouteLoaderData, Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import ClientInvoiceBundleForm from "Components/ClientInvoiceBundle/ClientInvoiceBundleForm";
import Paper from "Components/UI/Paper";
import {
  updateClientInvoiceBundle,
  deleteClientInvoiceBundle,
} from "API/swesum";
import usePost2 from "Hooks/usePost";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function ClientInvoiceBundleCard() {
  const { clientInvoiceBundle, files, clients, invoices } =
    useRouteLoaderData("bundle");
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { openSuccess, openError } = usePopupNotificationContext();
  const [formData, setFormData] = useState({
    Id: clientInvoiceBundle.Id,
    Amount: clientInvoiceBundle.Amount,
    SystemStatus: clientInvoiceBundle.SystemStatus,
    ParseStatus: clientInvoiceBundle.ParseStatus,
    ParseMessage: clientInvoiceBundle.ParseMessage,
    FileId: clientInvoiceBundle.FileId,
    InvoiceId: clientInvoiceBundle.InvoiceId,
    Status: clientInvoiceBundle.Status,
    CreateTime: clientInvoiceBundle.CreateTime,
    Title: clientInvoiceBundle.Title,
    OCR: clientInvoiceBundle.OCR,
  });

  const updateInvoiceReq = usePost2({
    mtnFunc: (body) => {
      return updateClientInvoiceBundle(clientInvoiceBundle.Id, body);
    },
    onSuccess: () => {
      openSuccess("Sparat", 3000);
    },
    onError: () => {
      openError("Ett fel har uppstått vid uppdatering av fakturan", 2000);
    },
  });
  const deleteInvoiceReq = usePost2({
    mtnFunc: () => deleteClientInvoiceBundle(clientInvoiceBundle.Id),
    onError: () => {
      closeDialog();
      openError("Ett fel uppstod när fakturan sparades");
    },
    onSuccess: () => {
      closeDialog();
      navigate("/clientinvoicebundle");
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const updateInvoicee = () => {
    updateInvoiceReq.post(formData);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Paper>
        <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
          Fakturabuntkort
        </Typography>
        {formData && (
          <ClientInvoiceBundleForm
            formData={formData}
            files={files}
            clients={clients}
            invoices={invoices}
            handleInputChange={handleInputChange}
          />
        )}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={() => navigate(-1)} sx={{ ml: 1 }}>
            Stäng
          </Button>
          <Button onClick={updateInvoicee} variant="contained" sx={{ ml: 3 }}>
            Spara
          </Button>
        </Grid>
      </Paper>

      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>{"Ta bort faktura"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              "Fakturan kommer att tas bort från systemet. Åtgärden går inte att ångra."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Stäng</Button>
          <Button
            color="error"
            onClick={() => deleteInvoiceReq.post()}
            autoFocus
          >
            Ta bort
          </Button>
        </DialogActions>
      </Dialog>
      {updateInvoiceReq.loading && <Typography>{"Laddar"}</Typography>}
      {updateInvoiceReq.error && (
        <Typography color={"error"}>
          {JSON.stringify(updateInvoiceReq.error.response?.details)}
        </Typography>
      )}
    </>
  );
}
